<template>
  <div class="innerItem settingInroom">
    <div class="mb15">
      <p class="innerTitle setLabel">체크아웃</p>
      <div class="mb10">
        <div class="checkbox">
          <input type="checkbox" id="inroom_checkout_true" v-model="inroom.checkoutTrue">
          <label for="inroom_checkout_true">체크아웃 성공 페이지</label>
        </div>
        <div v-if="inroom.checkoutTrue" class="input inroomLink mt5" @click="setLink('checkoutTrueUrl')">
          {{ getPageName(inroom.checkoutTrueUrl) }}
        </div>
      </div>
      <div>
        <div class="checkbox mb5">
          <input type="checkbox" id="inroom_checkout_false" v-model="inroom.checkoutFalse">
          <label for="inroom_checkout_false">체크아웃 불가 페이지</label>
        </div>
        <p class="sysMessage">룸차지 등이 있어 체크아웃 할 수 없는 경우</p>
        <div v-if="inroom.checkoutFalse" class="input inroomLink mt5" @click="setLink('checkoutFalseUrl')">
          {{ getPageName(inroom.checkoutFalseUrl) }}
        </div>
      </div>
    </div>
    <div
      v-if="setLinkLayer"
      class="layer setLinkLayer">
      <div class="inner">
        <button type="button" class="btnClose" @click="setLinkApply(false)"><span class="blind">close</span></button>
        <SetLink
          :link="linkInfo"
          :fix="['page']" />
        <div class="btns">
          <button type="button" class="btn btnFull btnPrimary" @click="setLinkApply(true)">{{locale.apply}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink'

export default {
  name: 'SetInroom',
  props: [
    'locale',
    'inroom'
  ],
  components: {
    SetLink
  },
  computed: {
    pages () {
      return this.$store.getters['page/list']
    }
  },
  created () {
    this.$store.dispatch('page/setPageListData')
  },
  data () {
    return {
      linkInfo: null,
      linkInfoTarget: null,
      setLinkLayer: false
    }
  },
  methods: {
    getPageName (page) {
      const id = page.pageId
      const name = typeof (id) === 'undefined' || id === ''
        ? this.locale.link_page_placeholder
        : typeof (this.pages.find(x => x.pageData.id === id)) === 'undefined'
          ? this.locale.link_page_notexist
          : this.pages.find(x => x.pageData.id === id).pageData.title
      const pageIdInput = page.pageId_input_active && page.pageIdInput
      return pageIdInput || name
    },
    setLink (target) {
      const link = this._.cloneDeep(this.inroom[target])
      this.linkInfoTarget = target
      this.setLinkLayer = true
      this.linkInfo = link
    },
    setLinkApply (isApply) {
      if (isApply) {
        if (window.confirm(this.locale.confirm_apply)) {
          const target = this.linkInfoTarget
          this.inroom[target] = this.linkInfo
          this.linkInfo = null
          this.linkInfoTarget = null
          this.setLinkLayer = false
        }
      } else {
        if (window.confirm(this.locale.confirm_cancel)) {
          this.linkInfo = null
          this.linkInfoTarget = null
          this.setLinkLayer = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inroomLink {
  color: $color-blue;
  cursor: pointer;
}
.setLinkLayer {
  .inner {
    max-width: 400px;
  }
}
</style>
